<template>
    <div class="fn-search mb-2" :class="{ 'open': openSearch }">
        <div class="search-icon"
             @click="toggleSearch()">
            <svg aria-hidden="true"
                 focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path>
            </svg>
        </div>

        <div class="fn-search-form" v-show="openSearch">
            <autocomplete
                @focusout="clear()"
                tabindex="0"

                autofocus
                baseClass="field"
                :ref="'autocomplete'"
                placeholder="Search DAX Formulas..."
                @submit="onSubmit"
                :search="search">
            </autocomplete>
            <div @click="clear()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    <path d="M0 0h24v24H0z" fill="none" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>

import Autocomplete from '@trevoreyre/autocomplete-vue'

export default {
    name: "DaxFormula",
    components: {
        Autocomplete
    },
    data: () => {
        return {
            openSearch: false,
        };
    },
    methods: {
        search(input) {
            if (input.length < 1) { return [] }
            let dax_functions = ["ABS", "ACOS", "ACOSH", "ADDCOLUMNS", "ADDMISSINGITEMS", "ALL", "ALLCROSSFILTERED", "ALLEXCEPT", "ALLNOBLANKROW", "ALLSELECTED", "AND", "APPROXIMATEDISTINCTCOUNT", "ASIN", "ASINH", "ATAN", "ATANH", "AVERAGE", "AVERAGEA", "AVERAGEX", "BETA.DIST", "BETA.INV", "BLANK", "CALCULATE", "CALCULATETABLE", "CALENDAR", "CALENDARAUTO", "CEILING", "CHISQ.INV", "CHISQ.INV.RT", "CLOSINGBALANCEMONTH", "CLOSINGBALANCEQUARTER", "CLOSINGBALANCEYEAR", "CODE", "COMBIN", "COMBINA", "CONCATENATE", "CONCATENATEX", "CONFIDENCE.NORM", "CONFIDENCE.T", "CONTAINS", "CONTAINSSTRING", "CONTAINSSTRINGEXACT", "CONVERT", "COS", "COSH", "COUNT", "COUNTA", "COUNTAX", "COUNTBLANK", "COUNTROWS", "COUNTX", "CROSSFILTER", "CROSSJOIN", "CURRENCY", "CUSTOMDATA", "DATATABLE", "DATE", "DATEADD", "DATEDIFF", "DATESBETWEEN", "DATESINPERIOD", "DATESMTD", "DATESQTD", "DATESYTD", "DATEVALUE", "DAY", "DEGREES", "DISTINCT (column)", "DISTINCT (table)", "DISTINCTCOUNT", "DISTINCTCOUNTNOBLANK", "DIVIDE", "EARLIER", "EARLIEST", "EDATE", "ENDOFMONTH", "ENDOFQUARTER", "ENDOFYEAR", "EOMONTH", "ERROR", "EVEN", "EXACT", "EXCEPT", "EXP", "EXPON.DIST", "FACT", "FALSE", "FILTER", "FILTERS", "FIND", "FIRSTDATE", "FIRSTNONBLANK", "FIXED", "FLOOR", "FORMAT", "GCD", "GENERATE", "GENERATEALL", "GENERATESERIES", "GEOMEAN", "GEOMEANX", "GROUPBY", "HASONEFILTER", "HASONEVALUE", "HOUR", "IF", "IFERROR", "IN", "CONTAINSROW", "INT", "INTERSECT", "ISBLANK", "ISCROSSFILTERED", "ISEMPTY", "ISERROR", "ISEVEN", "ISFILTERED", "ISINSCOPE", "ISLOGICAL", "ISNONTEXT", "ISNUMBER", "ISO.CEILING", "ISONORAFTER", "ISSELECTEDMEASURE", "ISTEXT", "KEEPFILTERS", "LASTDATE", "LASTNONBLANK", "LCM", "LEFT", "LEN", "LN", "LOG", "LOG10", "LOOKUPVALUE", "LOWER", "MAX", "MAXA", "MAXX", "MEDIAN", "MEDIANX", "MID", "MIN", "MINA", "MINUTE", "MINX", "MOD", "MONTH", "MROUND", "NATURALINNERJOIN", "NATURALLEFTOUTERJOIN", "NEXTDAY", "NEXTMONTH", "NEXTQUARTER", "NEXTYEAR", "NORM.DIST", "NORM.INV", "NORM.S.DIST", "NORM.S.INV", "NOT", "NOW", "ODD", "OPENINGBALANCEMONTH", "OPENINGBALANCEQUARTER", "OPENINGBALANCEYEAR", "OR", "PARALLELPERIOD", "PATH", "PATHCONTAINS", "PATHITEM", "PATHITEMREVERSE", "PATHLENGTH", "PERCENTILE.EXC", "PERCENTILE.INC", "PERCENTILEX.EXC", "PERCENTILEX.INC", "PI", "POISSON.DIST", "POWER", "PREVIOUSDAY", "PREVIOUSMONTH", "PREVIOUSQUARTER", "PREVIOUSYEAR", "PRODUCT", "PRODUCTX", "QUOTIENT", "RADIANS", "RAND", "RANDBETWEEN", "RANK.EQ", "RANKX", "RELATED", "RELATEDTABLE", "REMOVEFILTERS", "REPLACE", "REPT", "RIGHT", "ROUND", "ROUNDDOWN", "ROUNDUP", "ROW", "SAMEPERIODLASTYEAR", "SAMPLE", "SEARCH", "SECOND", "SELECTCOLUMNS", "SELECTEDMEASURE", "SELECTEDMEASUREFORMATSTRING", "SELECTEDMEASURENAME", "SELECTEDVALUE", "SIGN", "SIN", "SINH", "SQRT", "SQRTPI", "STARTOFMONTH", "STARTOFQUARTER", "STARTOFYEAR", "STDEV.P", "STDEV.S", "STDEVX.P", "STDEVX.S", "SUBSTITUTE", "SUBSTITUTEWITHINDEX", "SUM", "SUMMARIZE", "SUMMARIZECOLUMNS", "SUMX", "SWITCH", "T.DIST", "T.DIST.2T", "T.DIST.RT", "T.INV", "T.INV.2t", "TAN", "TANH", "TIME", "TIMEVALUE", "TODAY", "TOPN", "TOTALMTD", "TOTALQTD", "TOTALYTD", "TREATAS", "TRIM", "TRUE", "TRUNC", "UNICHAR", "UNION", "UPPER", "USERELATIONSHIP", "USERNAME", "UTCNOW", "UTCTODAY", "VALUE", "VALUES", "VAR", "VAR.P", "VAR.S", "VARX.P", "VARX.S", "WEEKDAY", "WEEKNUM", "XIRR", "XNPV", "YEAR", "YEARFRAC"];
            return dax_functions.filter(fn => {
                return fn.toLowerCase()
                    .startsWith(input.toLowerCase())
            })
        },
        onSubmit(result) {
            window.open('https://info.enterprisedna.co/dax-function-guide/' + result.toLowerCase())
        },
        toggleSearch(res) {
            this.openSearch = ! this.openSearch;
            this.$nextTick(() => {
                this.$refs.autocomplete.$refs["input"].focus();
            });
        },
        clear() {
            this.$refs.autocomplete.value = '';
            this.openSearch = false;
        }
    }
}
</script>

<style scoped>



</style>
